import {
  Card, Box, Container,
} from '@mui/material';
import style from './style';

type LoginContainer = {
  children: JSX.Element | JSX.Element[];
  onSubmit: () => void;

}

const LoginContainer = ({ children, onSubmit }: LoginContainer): JSX.Element => {
  return (
    <Box component={ style.box.component } sx={ style.box.sx }>
      <Container maxWidth={ style.container.maxWidth } sx={ style.container.sx }>
        <Card elevation={ style.card.elevation } sx={ style.card.sx }>
          <form noValidate onSubmit={ onSubmit }>
            { children }
          </form>
        </Card>
      </Container>
    </Box>
  );
};

export default LoginContainer;
